import type { INetworkStatusRepository } from '@/domain/repositories/INetworkStatusRepository';
import type { NetworkStatus } from '@/domain/entities/NetworkStatus';

/**
 * Use case responsável por observar mudanças no status de rede.
 * Retorna o status atual e permite registrar um subscriber.
 */
export class ObserveNetworkStatusUseCase {
  constructor(private readonly repository: INetworkStatusRepository) {}

  getCurrentStatus(): NetworkStatus {
    return this.repository.getCurrent();
  }

  subscribe(onChange: (status: NetworkStatus) => void): () => void {
    return this.repository.subscribe(onChange);
  }
}
